import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { useUpdateIngestionPolicies } from '../hooks';

type Props = {
  onClose: () => void;
};

export const TEXT = {
  ID: 'block-unknown-events',
  TITLE: 'Block unknown events?',
  BODY_TEXT_1: 'Prevent new event definitions from being added to this project.',
  BODY_TEXT_2: 'Listed events will continue to be saved and used to trigger journeys.',
  DESTRUCTIVE_BUTTON_TEXT: 'Block unknown events',
};

export const BlockUnknownEventsModal = ({ onClose }: Props) => {
  const { block } = useUpdateIngestionPolicies();

  const handleBlockUnknownEventsClick = async () => {
    await block();
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{TEXT.TITLE}</ModalHeader>
      <ModalBody>
        <Body2>{TEXT.BODY_TEXT_1}</Body2>
        <Body2>{TEXT.BODY_TEXT_2}</Body2>
      </ModalBody>
      <ModalFooter onClose={onClose}>
        <DestructiveButton onClick={handleBlockUnknownEventsClick} size={BUTTON_SIZES.LARGE}>
          {TEXT.DESTRUCTIVE_BUTTON_TEXT}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
